// Sistema de logging para produção
const isDevelopment = import.meta.env.DEV;
const isProduction = import.meta.env.PROD;

export const logger = {
  // Log de erro (sempre ativo)
  error: (message: string, ...args: any[]) => {
    if (isDevelopment) {
      console.error(`[ERROR] ${message}`, ...args);
    }
    // Em produção, enviar para serviço de monitoramento
    if (isProduction) {
      // TODO: Integrar com Sentry ou outro serviço
      console.error(`[ERROR] ${message}`);
    }
  },

  // Log de warning (apenas em desenvolvimento)
  warn: (message: string, ...args: any[]) => {
    if (isDevelopment) {
      console.warn(`[WARN] ${message}`, ...args);
    }
  },

  // Log de info (apenas em desenvolvimento)
  info: (message: string, ...args: any[]) => {
    if (isDevelopment) {
      console.info(`[INFO] ${message}`, ...args);
    }
  },

  // Log de debug (apenas em desenvolvimento)
  debug: (message: string, ...args: any[]) => {
    if (isDevelopment) {
      console.debug(`[DEBUG] ${message}`, ...args);
    }
  },

  // Log de sucesso (apenas em desenvolvimento)
  success: (message: string, ...args: any[]) => {
    if (isDevelopment) {
      console.log(`[SUCCESS] ${message}`, ...args);
    }
  }
};

// Função para sanitizar dados sensíveis
export const sanitizeLogData = (data: any): any => {
  if (typeof data !== 'object' || data === null) {
    return data;
  }

  const sensitiveKeys = ['password', 'token', 'key', 'secret', 'auth', 'credential'];
  const sanitized = { ...data };

  for (const key in sanitized) {
    if (sensitiveKeys.some(sensitive => key.toLowerCase().includes(sensitive))) {
      sanitized[key] = '[REDACTED]';
    } else if (typeof sanitized[key] === 'object') {
      sanitized[key] = sanitizeLogData(sanitized[key]);
    }
  }

  return sanitized;
};
